import React from 'react';
import styles from './Label.module.css';

const Label = ({ title }) => {
  return (
    <div className={styles['label_main']}>
      <label for="html">{title}</label>
    </div>
  );
};

export default Label;
